import React, { Component } from "react";
import axios from "axios";
import xss from "xss";
import { connect } from "react-redux";

import { Tooltip } from "./components";
import { console } from "../utils/functions";
import { DeleteIcon } from "../utils/components/icons";
import { messageActions } from '../actions';

class FileItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filenameSize: 40,
      filename: "",
      fileToUpload: null,
      message: null,
      uploadError: null,
    };
    this.onChange = this.onChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onUpload = this.onUpload.bind(this);
  }

  // truncate filename (DB has only 50 chars)
  truncateFilename = (filename) => {
    if (!filename) return "";
    return String(filename).replace(/\.pdf$/i, "").substring(0, this.state.filenameSize);
  };

  onChange(e) {
    this.setState({ filename: this.truncateFilename(xss(e.target.value)), message: null });
  }

  onUpload(e) {
    e.preventDefault();
    let filename = this.state.filename, file = this.state.fileToUpload, item = this.props.item;
    if (!filename || filename === ".pdf") {
      this.setState({ uploadError: new Error("Geben Sie einen Dateinamen an") });
      return false;
    }
    if ((!item.fileId && !file) || (file && file.type !== "application/pdf")) {
      this.setState({ uploadError: new Error("Wählen Sie eine PDF-Datei aus") });
      return false;
    }
    this.setState({ uploadError: null, message: null });
    const parameter = new URLSearchParams();
    let fileOrder = item.fileOrder;
    if (item && item.newItem) {
      fileOrder = false;
    }
    parameter.append("fileOrder", fileOrder ? xss(fileOrder) : "");
    parameter.append("filename", xss(filename));
    // Workaround: replace utf-8 with latin1 characters in filename
    const params = parameter.toString()
      .replace("%C3%A4", "%" + String("ä").charCodeAt(0).toString(16).toUpperCase())
      .replace("%C3%B6", "%" + String("ö").charCodeAt(0).toString(16).toUpperCase())
      .replace("%C3%BC", "%" + String("ü").charCodeAt(0).toString(16).toUpperCase())
      .replace("%C3%84", "%" + String("Ä").charCodeAt(0).toString(16).toUpperCase())
      .replace("%C3%96", "%" + String("Ö").charCodeAt(0).toString(16).toUpperCase())
      .replace("%C3%9C", "%" + String("Ü").charCodeAt(0).toString(16).toUpperCase())
      .replace("%C2%A7", "%" + String("§").charCodeAt(0).toString(16).toUpperCase())
      .replace("%C3%9F", "%" + String("ß").charCodeAt(0).toString(16).toUpperCase());
    //get url of config.js
    const uploadFileRequestData = this.props.configStorage.getRequestData("uploadFile", "post", file);
    const url = uploadFileRequestData.url + xss(item.fileId) + "&" + params;

    const axiosConfig = uploadFileRequestData.request.config;
    const sendData = uploadFileRequestData.dataToSend;
    const type = uploadFileRequestData.request.type;

    axios[type](url, sendData, axiosConfig).then(res => {
      if (res && res.status >= 200 && res.status < 300) {
        this.setState({ message: "Datei erfolgreich gespeichert", filename: "", fileToUpload: null });
        this.props.dispatch(messageActions.fileMessage({ item: this.props.item, message: true, error: false }));
        if (typeof this.props.loadMandant === "function") return this.props.loadMandant();
      } else if (res && res.status === 304) {
        this.setState({ uploadError: new Error("Die Datei ist schon gespeichert.") });
        this.props.dispatch(messageActions.fileMessage({ item: this.props.item, message: false, error: true }));
      } else {
        this.setState({ uploadError: new Error("Status " + res.status + ": " + res.statusText) });
        this.props.dispatch(messageActions.fileMessage({ item: this.props.item, message: false, error: true }));
      }
    })
      .catch(error => {
        console.log("f1", error);
        this.setState({ uploadError: new Error("Fehler beim Speicher der Datei: " + error.message) });
        this.props.dispatch(messageActions.fileMessage({ item: this.props.item, message: false, error: true }));
      });
  }

  onDelete(e) {
    this.props.deleteFile(e, this.props.item.fileId);
    this.setState({ filename: "" });
  }

  setFileInState = e => {
    let file = e.target.files[0];
    let fileToUpload = file;
    if ((!this.props.item.fileId && !file) || (file && file.type !== "application/pdf")) {
      this.setState({ uploadError: true, error: new Error("Wählen Sie eine PDF-Datei aus"), message: null });
      return false;
    }
    let filename = this.truncateFilename(file.name);
    if (!filename || filename === ".pdf") {
      this.setState({ uploadError: true, error: new Error("Geben Sie einen Dateinamen an"), message: null });
      return false;
    }
    //save multipart file in state
    this.setState({ fileToUpload, filename, message: null });
  };

  render() {
    const filename = this.state.filename || this.truncateFilename(this.props.item.filename);
    return (
      <>
        <tr className="col-12">
          <td className="col-2">
            <label className="fs-5 text-gray" htmlFor="filename">Dateiname</label>
            <Tooltip>Der Dateiname kann maximal {this.state.filenameSize} Zeichen enthalten. Die Endung ".pdf" wird automatisch angefügt.</Tooltip>
          </td>
          <td className="col-4">
            <input
              type="text"
              id="filename"
              name="filename"
              className="w-100"
              maxLength={this.state.filenameSize}
              value={filename}
              onChange={this.onChange}
              disabled={this.props.disabled}
            />
            {this.state.uploadError && this.props.messageStorage.displayFileError(this.props.item.fileId)
              ? <div className="alert alert-danger p-1">{this.state.uploadError.message
                ? this.state.uploadError.message
                : "Fehler beim Speichern der Datei"
              }
              </div>
              : null
            }
            {this.state.message && this.props.messageStorage.displayFileMessage(this.props.item.fileId)
              ? <div className="alert alert-info p-1">{this.state.message}</div>
              : null
            }
          </td>
          <td>
            <label className="btn btn-default col-3">
              PDF Datei auswählen
              <input
                className="d-none"
                type="file"
                id="fileToUpdate"
                name="fileContent"
                accept=".pdf"
                onChange={this.setFileInState}
                disabled={this.props.disabled}
              />
            </label>
            <button type="button"
              className="btn btn-primary col-2"
              onClick={this.onUpload}
              disabled={!this.state.fileToUpload && !this.state.filename}
            >
              {this.props.buttonLabel}
            </button>
            {
              this.props.displayDelete
                ? <button type="button"
                  onClick={this.onDelete}
                  className="btn btn-danger col-1 ms-one"
                >
                  <DeleteIcon />
                </button>
                : null
            }
          </td>
        </tr>
      </>
    );
  }
}

export default connect((store) => {
  return {
    configStorage: store.configStorage,
    messageStorage: store.messageStorage
  };
})(FileItem);
